const Payment = {

    // FIELDS
    "invoice": "الفاتورة",
    "mode": "الوضع",
    "payment_date": "التاريخ",
    "payment_amount": "المبلغ",
    "reference_no": "رقم المرجع",
    "remark": "ملاحظة",
    "search": "بحث",

    // BUTTON
    "confirm": "تأكيد",

    // PAGE HEADER
    "payment": "الدفع",

    // TOOLTIP
    "approve": "موافقة",
    "reject": "رفض",

    // SWEET ALERT
    "approve_confirm_text": "هل أنت متأكد أنك تريد الموافقة على الدفع؟",
    "reject_confirm_text": "هل أنت متأكد أنك تريد رفض الدفع؟",
    "status": "الحالة",
    "status_text": "تم تغيير الحالة بنجاح",

    // ERROR
    "error_invoice": "اختر الفاتورة",
    "error_positive": "أدخل مبلغًا موجبًا فقط",
    "error_mode": "اختر وضع الدفع",
    "error_payment_date": "اختر التاريخ",
    "error_payment_amount": "أدخل المبلغ",
    "error_reference_no": "أدخل رقم المرجع",
    "error_remark": "أدخل ملاحظة",

    // TABLE HEADER
    "table_invoice": "الفاتورة",
    "table_payment_mode": "الوضع",
    "table_payment_date": "التاريخ",
    "table_payment_amount": "المبلغ",
    "table_txn_id": "معرف المعاملة",
    "table_remark": "ملاحظة",
    "table_status": "الحالة",
}

export default Payment;